module.exports = "mutation ShouldDisplayUpsaleTrigger {\n  shouldDisplayUpsaleTrigger {\n    shouldDisplayUpsale\n  }\n}\n"